<template>
    <div class="timeline">
        <div class="timeline-block" v-for="(value, key) in timelineData" v-bind:key="key">
            <div class="timeline-item-left">
                <div class="timeline-item-time-left" v-show="value.left">{{key}}</div>
                <div class="timeline-item-left-text" v-show="value.left" v-for="(item,index) in value.left"
                     v-bind:key="index">
                    {{item.content}}<span>{{item.desc}}</span></div>
            </div>
            <div class="timeline-item-middle" v-bind:class="value.level">
                <div class="circle" v-bind:class="value.level"></div>
            </div>
            <div class="timeline-item-right">
                <div class="timeline-item-time-right" v-show="!value.left">{{key}}</div>
                <div class="timeline-item-time-left" v-show="value.left"></div>
                <div class="timeline-item-right-content " v-bind:class="item.type" v-show="value.right"
                     v-for="(item,index) in value.right"
                     v-bind:key="index">

                    {{item.content}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'TimeLine',
        data() {
            return {}
        },
        props: {
            timelineData: Object,
            countsMap: Object
        },
        mounted() {
            // console.log(this.timelineData)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .timeline-block {
        display: flex;
        justify-content: space-between;
    }

    .timeline-item-left {
        /*background-color: #42b983;*/
        width: 47vw;
        padding-left: 5px;
    }

    .timeline-item-middle {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-flow: column;
        width: 2px;
        min-height: 50px;
    }

    .timeline-item-right {
        width: 47vw;
        padding-right: 5px;

    }

    .circle {
        width: 4vw;
        height: 4vw;
        background: #ffffff;
        border-radius: 50%;
        margin-top: 10px;
    }

    .timeline-item-time-left {
        height: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        font-weight: bolder;
    }

    .timeline-item-time-right {
        font-size: 14px;
        height: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;

        font-weight: bolder;
    }

    .timeline-item-left-text {
        font-size: 12px;
        text-align: left;
        margin-bottom: 7px;
    }

    .timeline-item-left-text span {
        color: gray;
        opacity: 0.7;
    }

    .timeline-item-right {
        font-size: 12px;
    }

    .timeline-item-right-content {
        border-radius: 5px;
        padding: 5px;
        text-align: left;
        color: white;
        margin-bottom: 7px;
    }

</style>
